import { render, staticRenderFns } from "./commonProblem.vue?vue&type=template&id=40cfeff0&scoped=true&"
import script from "./commonProblem.vue?vue&type=script&lang=js&"
export * from "./commonProblem.vue?vue&type=script&lang=js&"
import style0 from "./commonProblem.vue?vue&type=style&index=0&id=40cfeff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cfeff0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40cfeff0')) {
      api.createRecord('40cfeff0', component.options)
    } else {
      api.reload('40cfeff0', component.options)
    }
    module.hot.accept("./commonProblem.vue?vue&type=template&id=40cfeff0&scoped=true&", function () {
      api.rerender('40cfeff0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/about/commonProblem.vue"
export default component.exports